import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import generalStyles from './style/general.css';
import alignContentStyles from './style/alignContent.css';
import justifyContentStyles from './style/justifyContent.css';

const MAX_COLUMNS = 12;
const PCT_ROUND = 5;

export default function GridItem({
  alignContent,
  children,
  columns,
  columnSpan,
  columnSpanS,
  columnSpanM,
  columnSpanL,
  fullWidth,
  justifyContent,
}) {
  const width = fullWidth
    ? 'width-100'
    : getWidthClassName(columnSpan, columns);
  const className = cx(
    generalStyles.gridItem,
    alignContentStyles[alignContent],
    justifyContentStyles[justifyContent],
    width,
    {
      [`breakPointS-${getWidthClassName(columnSpanS, columns)}`]: columnSpanS,
      [`breakPointM-${getWidthClassName(columnSpanM, columns)}`]: columnSpanM,
      [`breakPointL-${getWidthClassName(columnSpanL, columns)}`]: columnSpanL,
    }
  );
  return <li className={className}>{children}</li>;
}

function getWidthClassName(columnSpan, columns) {
  // fraction-based
  if (MAX_COLUMNS % columns === 0) {
    const scale = MAX_COLUMNS / columns;
    const numerator = columnSpan * scale;
    const denominator = columns * scale;
    return `width-${numerator}/${denominator}`;
  }
  // percentage-based
  return roundToNearestN(100 / columns * columnSpan, PCT_ROUND);
}

function roundToNearestN(i, N) {
  return Math.ceil(i / N) * N;
}

GridItem.propTypes = {
  alignContent: PropTypes.oneOf(Object.keys(alignContentStyles)),
  justifyContent: PropTypes.oneOf(Object.keys(justifyContentStyles)),
  children: PropTypes.node.isRequired,
  columns: PropTypes.number,
  columnSpan: PropTypes.number,
  columnSpanS: PropTypes.number,
  columnSpanM: PropTypes.number,
  columnSpanL: PropTypes.number,
  fullWidth: PropTypes.bool,
};

GridItem.defaultProps = {
  columns: 2,
  columnSpan: 1,
  columnSpanS: null,
  columnSpanM: null,
  columnSpanL: null,
  fullWidth: false,
};



// WEBPACK FOOTER //
// ./packages/marvel-ui-grid/GridItem/index.js